import { render } from "./DetailView.vue?vue&type=template&id=55386142&scoped=true"
import script from "./DetailView.vue?vue&type=script&lang=js"
export * from "./DetailView.vue?vue&type=script&lang=js"

import "./DetailView.vue?vue&type=style&index=0&id=55386142&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55386142"]])

export default __exports__